import { useTranslation } from '../../i18n/LanguageProvider';
import IconLink from '../common/IconLink';


export default function Bio() {
  const { t } = useTranslation();

  return (
    <div className="card profile-card mb-4">
      <div className="card-body text-center">
        <img
          src={require('./images/self.jpg')}
          alt="Frederico Schardong"
          className="rounded-circle mb-4"
          width="250"
          height="250" />
          <h1 className="profile-name mb-1">Frederico Schardong, PhD</h1>
          <p className="text-muted mb-1">{t('profile.assistantProfessor')}</p>
          <p className="mb-1"><a href="https://ufsc.br/"  target="_blank" rel="noopener noreferrer" >{t('profile.university')}</a></p>
          <IconLink href="mailto:frederico.schardong@ufsc.br" label={t('profile.contact')}>
            <span className="d-flex justify-content-center mb-1">
              <i className='icon-mail'></i>&nbsp;frederico.schardong@ufsc.br
            </span>
          </IconLink>
          <IconLink className="p-1" href="https://scholar.google.com/citations?user=MoMsVnkAAAAJ&hl=en&oi=ao" label="Google Scholar"><i className="icon-google-scholar"></i></IconLink>
          <IconLink className="p-1" href="https://www.linkedin.com/in/fredericoschardong/" label="Linkedin"><i className="icon-linkedin"></i></IconLink>
          <IconLink className="p-1" href="https://github.com/fredericoschardong/" label="Github"><i className="icon-github"></i></IconLink>
          <IconLink className="p-1" href="https://lattes.cnpq.br/8896031429725811/" label="Lattes"><i className="icon-lattes"></i></IconLink>
        </div>
    </div>
  );
}
